import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

// Critical routes - load immediately
import Index from "./pages/Index";
import Auth from "./pages/Auth";

// Non-critical routes - lazy load
const Prognosen = lazy(() => import("./pages/Prognosen"));
const Abstimmungen = lazy(() => import("./pages/Abstimmungen"));
const Statistiken = lazy(() => import("./pages/Statistiken"));
const Ergebnisse = lazy(() => import("./pages/Ergebnisse"));
const LineupBuilder = lazy(() => import("./pages/LineupBuilder"));
const CommunityFeed = lazy(() => import("./pages/CommunityFeed"));
const Admin = lazy(() => import("./pages/Admin"));
const MatchDetail = lazy(() => import("./pages/MatchDetail"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Spieler = lazy(() => import("./pages/Spieler"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const ProfileEdit = lazy(() => import("./pages/ProfileEdit"));
const FollowList = lazy(() => import("./pages/FollowList"));
const Messages = lazy(() => import("./pages/Messages"));
const Search = lazy(() => import("./pages/Search"));
const FanGallery = lazy(() => import("./pages/FanGallery"));
const PuanDurumu = lazy(() => import("./pages/PuanDurumu"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div></div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/prognosen" element={<Prognosen />} />
            <Route path="/abstimmungen" element={<Abstimmungen />} />
            <Route path="/statistiken" element={<Statistiken />} />
            <Route path="/ergebnisse" element={<Ergebnisse />} />
            <Route path="/lineup-builder" element={<LineupBuilder />} />
            <Route path="/community" element={<CommunityFeed />} />
            <Route path="/match/:matchId" element={<MatchDetail />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/spieler" element={<Spieler />} />
            <Route path="/profil" element={<ProfilePage />} />
            <Route path="/profil/edit" element={<ProfileEdit />} />
            <Route path="/follow-list" element={<FollowList />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/search" element={<Search />} />
            <Route path="/fan-gallery" element={<FanGallery />} />
            <Route path="/puan-durumu" element={<PuanDurumu />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
